import React, { useEffect, useMemo } from "react";
import { useCollection } from "api/hooks/useCollection";
import { Collections } from "api/model/Collections";
import { Car } from "api/model/Car";
import MaterialTable from "material-table";
import { BoxCard } from "ui/componentes/BoxCard";
import { LocalizationPTBr } from "util/MaterialTableUtil";
import { Brand } from "api/model/Brand";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import { isLoaded } from "react-redux-firebase";
import { AddBox } from "@material-ui/icons";

interface SelectCarsProps {
    open: boolean;
    onClose?: () => void;
    onSelectCars: (cars: Car[]) => void;
    filterOptions?: ((car: Car) => boolean)[];
}

const SelectCars: React.FC<SelectCarsProps> = ({
    open,
    onClose,
    onSelectCars,
    filterOptions,
}) => {
    const cars = useCollection<Car[]>({ collection: Collections.CARS }, true);

    useEffect(() => {
        cars.sort((car1, car2) => (car1.name < car2.name ? -1 : 1));
    }, [cars]);

    const brandsById =
        useCollection<{ [id: string]: Brand }>({
            collection: Collections.BRANDS,
        }) || {};

    let carsOptions = useMemo(() => {
        let carsFiltered: Car[] = [...cars];
        if (filterOptions) {
            filterOptions.forEach((filter) => {
                carsFiltered = carsFiltered.filter(filter);
            });
        }
        carsFiltered.sort((d1, d2) => (d1.name < d2.name ? -1 : 1));
        return carsFiltered;
    }, [cars, filterOptions]);

    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            disableBackdropClick
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>Adicionar Carros</DialogTitle>
            <DialogContent dividers>
                <MaterialTable
                    components={{ Container: BoxCard }}
                    title="Selecionar Carros"
                    columns={[
                        {
                            field: "brandId",
                            title: "Marca",
                            align: "center",
                            render: (car) => {
                                return brandsById[car.brandId]?.name;
                            },
                        },
                        {
                            field: "name",
                            title: "Nome",
                        },
                        {
                            field: "model",
                            title: "Modelo",
                        },
                        {
                            field: "classIRacingID",
                            title: "Classe",
                        },
                    ]}
                    data={carsOptions}
                    options={{
                        filtering: true,
                        selection: true,
                        draggable: false,
                        search: false,
                    }}
                    actions={[
                        {
                            icon: () => <AddBox color="primary" />,
                            tooltip: "Adicionar carros selecionados",
                            onClick: (event, cars) =>
                                onSelectCars(cars as Car[]),
                        },
                    ]}
                    isLoading={!isLoaded(cars)}
                    localization={LocalizationPTBr}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        if (onClose) {
                            onClose();
                        }
                    }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { SelectCars };
